export class PwaService {
	private swPath: string;

	constructor(swPath: string = '/sw.js?v=2') {
		this.swPath = swPath;
		this._init();
	}

	public async _init(): Promise<void> {
		if (!('serviceWorker' in navigator)) {
			console.warn('Service Worker non support\u00e9');
			return;
		}

		try {
			const registration = await navigator.serviceWorker.register(this.swPath);
			// console.log('Service Worker PWA enregistr\u00e9', registration);
		} catch (error) {
			console.error('Erreur enregistrement Service Worker PWA', error);
		}
	}
}

export const pwaService = new PwaService();